/*
 * @Author: your name
 * @Date: 2018-08-03 14:02:22
 * @LastEditTime: 2021-08-12 02:48:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /cloud-recruit/src/actions/file.js
 */
import * as types from 'constants/file';
import axios from 'axios';

import {message} from 'antd';

const REMOVE_UPLOAD_FILE = {type: types.REMOVE_UPLOAD_FILE};

export const removeUploadFIle = fileName => (dispatch,getState) => {
    let fd = new FormData();
    fd.append('fileName',fileName);
    axios.post(`${prefixUri}/uploadremove`,fd)
    .then(response=>{
        const {data} = response;
        if(data.success) {
            message.success('删除附件成功！');
        }else{
            message.error('删除附件失败！');
        }
    });
}
// 组件简历上传不需要弹框
export const removeUploadFIles = fileName => (dispatch,getState) => {
    let fd = new FormData();
    fd.append('fileName',fileName);
    axios.post(`${prefixUri}/uploadremove`,fd)
    .then(response=>{
        const {data} = response;
        if(data.success) {
            
        }
    });
}


// WEBPACK FOOTER //
// ./src/actions/file.js